import React from 'react';
import { cn } from '../../utils/cn';
import { SITE_ASSETS } from '../../constants/siteAssets';

const SiteLogo = ({ className, imgClassName, showText = false, textClassName }) => (
  <span className={cn('inline-flex items-center gap-3', className)}>
    <img
      src={SITE_ASSETS.logo}
      alt="Sizzle Legacies"
      className={cn('h-11 w-11 sm:h-12 sm:w-12 object-contain flex-shrink-0', imgClassName)}
    />
    {showText && (
      <span className={cn('font-serif font-semibold text-2xl tracking-tight', textClassName)}>
        Sizzle Legacies
      </span>
    )}
  </span>
);

export default SiteLogo;
